<template>
  <div id="app">
    <my-header />
    <router-view/>
    <my-footer />
    <cookie-consent ref="cookieConsentModal"/>
  </div>
</template>

<script>
import MyFooter from '@/components/footer/Footer.vue';
import MyHeader from '@/components/header/Header.vue';
import CookieConsent from '@/components/cookie-policy/CookieConsent.vue';

export default {
  name: 'App',
  components: { CookieConsent, MyFooter, MyHeader },
  mounted() {
    this.$refs.cookieConsentModal.checkIfUserAgreedToCookiePolicy();
  },
};
</script>

<style lang="scss">
#app {
  html {
    font-family: $brandFontFamily;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
}
</style>
